import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import { DashboardLayout } from './components/DashboardLayout';
import { useAuth } from './hooks/useAuth';
import { Companies } from './pages/Companies';
import { CompanyDetails } from './pages/CompanyDetails';
import { ArchivedCompanies } from './pages/ArchivedCompanies';
import { Dashboard } from './pages/Dashboard';
import { Login } from './pages/Login';
import { ChangePassword } from './pages/ChangePassword';
import { CompanyDashboard } from './pages/CompanyDashboard';
import { ManagerDashboard } from './pages/ManagerDashboard';
import { Messages } from './pages/Messages';
import { StaffManagement } from './pages/StaffManagement';
import { Jobs } from './pages/Jobs';
import { ManagerJobs } from './pages/ManagerJobs';
import { ManagerTeam } from './pages/ManagerTeam';
import { TimeEntries } from './pages/TimeEntries';
import { PendingApprovals } from './pages/PendingApprovals';
import { CompanySettings } from './pages/CompanySettings';
import { ResetPassword } from './pages/ResetPassword';

function App() {
  const { currentUser, loading, signOut, refreshUser } = useAuth();

  // Public route — must be checked before auth, outside BrowserRouter
  if (window.location.pathname === '/reset-password') {
    return <BrowserRouter><Routes><Route path="/reset-password" element={<ResetPassword />} /></Routes></BrowserRouter>;
  }

  // Handle password change completion - refresh user profile
  const handlePasswordChanged = async () => {
    await refreshUser();
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          fontSize: '18px',
          color: '#6b7280',
        }}
      >
        Loading...
      </div>
    );
  }

  if (!currentUser) {
    return <Login />;
  }

  // Show password change screen for company/manager users who need to change password
  if (currentUser.requirePasswordChange && (currentUser.userType === 'company' || currentUser.userType === 'manager')) {
    return <ChangePassword onPasswordChanged={handlePasswordChanged} />;
  }

  return (
    <BrowserRouter>
      <DashboardLayout user={currentUser} onLogout={signOut} companyName={currentUser.companyName} companyTimezone={currentUser.companyTimezone}>
        <Routes>
          {currentUser.userType === 'super_admin' && (
            <>
              <Route path="/" element={<Dashboard />} />
              <Route path="/companies" element={<Companies />} />
              <Route path="/companies/:companyId" element={<CompanyDetails />} />
              <Route path="/archived-companies" element={<ArchivedCompanies />} />
              <Route path="/messages" element={<Messages />} />
            </>
          )}
          {currentUser.userType === 'company' && (
            <>
              <Route path="/" element={<CompanyDashboard />} />
              <Route path="/staff" element={<StaffManagement />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/time-entries" element={<TimeEntries />} />
              <Route path="/approvals" element={<PendingApprovals />} />
              <Route path="/reports" element={<div style={{ padding: '40px' }}>Reports (Coming Soon)</div>} />
              <Route path="/settings" element={<CompanySettings />} />
            </>
          )}
          {currentUser.userType === 'manager' && (
            <>
              <Route path="/" element={<ManagerDashboard />} />
              <Route path="/jobs" element={<ManagerJobs />} />
              <Route path="/team" element={<ManagerTeam />} />
              <Route path="/time-entries" element={<TimeEntries />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/approvals" element={<PendingApprovals />} />
            </>
          )}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </DashboardLayout>
    </BrowserRouter>
  );
}

export default App;
